import React, { useState, useEffect } from 'react';
import Landing from '../components/Sections/Landing';

const sections = [
  {Component: Landing, },
];

function Home() {

  const [currentSection, setCurrentSection] = useState(0);
  const nextScreen = () => {
    setCurrentSection(currentSection + 1);
  }

  const PrevSection = currentSection > 0 ? sections[currentSection - 1] : null;
  const ThisSection = sections[currentSection];

  return (
    <>
      {/* Some pages slide in over top, while others start underneath the previous page */}
      {(PrevSection && !PrevSection.exitsOnTop) && <PrevSection.Component exiting={true} />}

      {<ThisSection.Component next={nextScreen} />}

      {(PrevSection && PrevSection.exitsOnTop) && <PrevSection.Component exiting={true} />}
    </>
  );
}

export default Home
